import { render, staticRenderFns } from "./VideoAdd.vue?vue&type=template&id=23d17b62&scoped=true"
import script from "./VideoAdd.vue?vue&type=script&lang=js"
export * from "./VideoAdd.vue?vue&type=script&lang=js"
import style0 from "./VideoAdd.vue?vue&type=style&index=0&id=23d17b62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d17b62",
  null
  
)

export default component.exports